import api from "./Api";
import { getAccessToken } from "./AuthenticationData.ts";
import { BASE_URL } from "./Context/config";

export interface PostSearchData {
  UserId: number;
  Query: string;
  Date: string;
}

export const GetProfileFromSearch = async (search: string) => {
  try {
    const response = await api.get(`${BASE_URL}/Search/Search`, {
      params: {
        search: search,
      },
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        withCredentials: true,
      },
    });

    return response;
  } catch (error) {
    throw error; // Re-throw the error so it can be handled by the calling function
  }
};

export const PostSearch = async (search: PostSearchData) => {
  const data = {
    UserId: search.UserId,
    Query: search.Query,
    Date: search.Date,
  };

  try {
    var authToken = getAccessToken();
    const response = await api.post(`${BASE_URL}/Search/PostSearch`, data, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    return { error: error.message };
  }
};

export const GetSearchQueries = async () => {
  try {
    var authToken = getAccessToken();
    const response = await api.get(`${BASE_URL}/Search/GetSearchQueries`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
    });

    return response;
  } catch (error) {
    return { error: error.message };
  }
};
